import {of as observableOf, Observable} from 'rxjs';

import {first} from 'rxjs/operators';
import {ConfirmDialog} from './confirm-dialog.component';
import {MatDialogRef, MatDialog} from '@angular/material/dialog';
import {Injectable} from '@angular/core';
import {MessageDialog} from './message-dialog.component';
import {Utilities} from '../utilities';
import {ErrorDialog} from './error-dialog.component';
import {LanguageService} from '../../language/language.service';
import {getApiErrorMessage} from '../../error/api-error';

@Injectable()
export class DialogsService {
  constructor(private dialog: MatDialog) {}

  public confirm(
    title: string,
    message: string,
    trueLabel?: string,
    falseLabel?: string,
  ): Observable<boolean> {
    let dialogRef: MatDialogRef<ConfirmDialog> = this.dialog.open(ConfirmDialog);

    dialogRef.componentInstance.title = title;
    dialogRef.componentInstance.message = message;

    if (trueLabel) {
      dialogRef.componentInstance.trueLabel = trueLabel;
    }
    if (falseLabel) {
      dialogRef.componentInstance.falseLabel = falseLabel;
    }

    return dialogRef.afterClosed();
  }

  public message(title: string, message: string, label?: string): Observable<any> {
    let dialogRef: MatDialogRef<MessageDialog> = this.dialog.open(MessageDialog);

    dialogRef.componentInstance.title = title;
    dialogRef.componentInstance.message = Utilities.linebreakTextToHTML(
      Utilities.escapeHTML(message),
    );

    if (label) {
      dialogRef.componentInstance.label = label;
    }

    return dialogRef.afterClosed();
  }

  private errorDialogOpened: boolean = false;

  public error(title: string, message: string, details: string, label?: string): Observable<any> {
    if (this.errorDialogOpened) {
      return observableOf(null);
    }
    this.errorDialogOpened = true;

    let dialogRef: MatDialogRef<ErrorDialog> = this.dialog.open(ErrorDialog);

    dialogRef.componentInstance.title = title;
    dialogRef.componentInstance.details = details;
    dialogRef.componentInstance.message = message;

    if (label) {
      dialogRef.componentInstance.label = label;
    }
    dialogRef.afterClosed().subscribe(() => {
      this.errorDialogOpened = false;
    });

    return dialogRef.afterClosed();
  }

  public webserviceError(
    error: any,
    title: string,
    message: string,
    languageResource: any,
  ): Observable<any> {
    let details: string = null;
    if (error != null) {
      const apiMessage = getApiErrorMessage(error);
      if (apiMessage != null) {
        details = apiMessage;
      } else if (typeof error.message === 'string') {
        details = error.message;
      } else if (typeof error === 'string') {
        details = error;
      }
    }

    return this.error(title, message, details).pipe(first());
  }

  public advancedWebserviceError(
    error: any,
    title: string,
    message: string,
    additionalMessage: string,
    languageResource: any,
  ): Observable<any> {
    let details: string = additionalMessage;
    if (error != null) {
      if (details) details += ' ';
      const apiMessage = getApiErrorMessage(error);
      if (apiMessage != null) {
        details += apiMessage;
      } else if (typeof error.message === 'string') {
        details += error.message;
      } else if (typeof error === 'string') {
        details += error;
      }
    }

    return this.error(title, message, details).pipe(first());
  }
}
